export enum Shortcut {
  A         = 'a',
  B         = 'b',
  C         = 'c',
  D         = 'd',
  E         = 'e',
  G         = 'g',
  I         = 'i',
  L         = 'l',
  M         = 'm',
  O         = 'o',
  P         = 'p',
  R         = 'r',
  S         = 's',
  T         = 't',
  V         = 'v',
  W         = 'w',
  X         = 'x',
  Z         = 'z',
  DIGIT_1   = '1',
  DIGIT_2   = '2',
  DIGIT_3   = '3',
  DELETE    = 'Delete',
  MINUS     = '-',
  PLUS      = '+',
  Z_SHIFT   = 'Z',
}
